<template>
    <b-container fluid class="animated fadeIn">
        <h1>Protesto - Exibir Erros</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                             <b-button class="mx-1 fonte-branca" v-b-toggle.collapseOpcoesPesquisa variant="primary"><i class="fa fa-filter"></i> Opções de pesquisa</b-button>
                            <CompExibirOcultarColuna 
                                :fields="fields"
                                :showColunms="showColunms" 
                                @toggleColuna="toggleColuna" />
                        </div>
                    </div>
                    <CompOpcoesPesquisa
                        :filtro="filtro"
                        :dados="dados"
                        @filtrar="filtrar"
                        @limparFiltro="limparFiltro"
                         />
                    <b-row class="d-flex justify-content-between mt-2">
                        <b-col align-self="end">
                            <div class="d-flex justify-content-between mb-3" style="float:right">
                                <div>
                                    <b-button class="mx-1 " variant="primary"  @click.prevent="encaminharParaDisponiveis" :disabled="!selecteds.length"><i class="fa fa-pencil-square-o"></i> Encaminhar para Disponíveis</b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col xs="12" md="12" class="mx-auto">
                            <b-col xs="12">
                                <div>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col>
                                            <label class="mt-3">Dívidas com Erros - Valor Total: <strong>R$ {{ configTable.totalGeral | currency }}</strong> &nbsp; Quantidade: <strong>{{ configTable.quantidadeGeral }}</strong></label>
                                        </b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                    <CompTabelaErrosProtesto
                                        :resultado="resultado"
                                        :fields="fields"
                                        :configTable="configTable"
                                        :selecteds="selecteds"
                                        @sortingChanged="consultarDividas"
                                        @consultarDividas="consultarDividas"
                                        @show="show"
                                        @hide="hide"
                                        />
                                    <b-row class="d-flex justify-content-between">
                                        <b-col align-self="end">
                                            <label style="float:right">Quantidade selecionada: {{ selecteds.length }} &nbsp; Valor Total: <strong>R$ {{ totalSelectedValue | currency }}</strong></label>
                                        </b-col>
                                    </b-row>

                                    <b-row class="d-flex justify-content-between">
                                        <b-col></b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-col>
                    </b-row>
                     <b-modal  ref="modalEndereco" size="lg" title="Ajustar Endereço" ok-title="Salvar" cancel-title="Fechar">
                        <div style="padding:10px">
                        <h1>Devedor Principal - Endereço</h1>
                        <b-card v-if="this.devedorEndereco">
                            <b-row>
                                <b-col md="12">
                                    <strong>Número CDA: </strong> {{this.devedorEndereco.numeroCda}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="12">
                                    <strong>Endereço: </strong> {{this.devedorEndereco.endereco}}
                                    <strong>Número: </strong> {{this.devedorEndereco.numeroEndereco}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="12">
                                    <strong>Complemento: </strong> {{this.devedorEndereco.complemento}}
                                    <strong>Bairro: </strong> {{this.devedorEndereco.bairro}}
                                </b-col>
                            </b-row>
                             <b-row>
                                <b-col md="12">
                                    <strong>Cidade: </strong> {{this.devedorEndereco.cidade.nome}}
                                    <strong>UF: </strong> {{this.devedorEndereco.uf.sigla}}
                                    <strong>CEP: </strong> {{this.devedorEndereco.cep}}
                                </b-col>
                            </b-row>
                            <hr/>
                            <strong>Incluir/Alterar</strong>
                            <b-form-group>
                            <b-row> 
                               <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group label="*CEP:" label-for="cepAlteracao" class="text-label">
                                        <b-form-input required @change="obterEnderecoPorCep()" v-model="devedorEnderecoAlteracao.cepAlteracao" type="number" id="cep" maxlength="8" />
                                    </b-form-group>
                                </b-col>
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group label="*Endereço:" label-for="enderecoAlteracao" class="text-label" style="margin-left: 15px;">
                                        <b-form-input v-model="devedorEnderecoAlteracao.enderecoAlteracao" type="text" id="endereco" maxlength="100" style="margin-left: 15px;"/>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group label="*Número:" label-for="numeroEnderecoAlteracao" class="text-label">
                                        <b-form-input v-model="devedorEnderecoAlteracao.numeroEnderecoAlteracao" type="text" id="numero" maxlength="10" />
                                    </b-form-group>
                                </b-col>
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group label="*Complemento:" label-for="complementoAlteracao" class="text-label" style="margin-left: 15px;">
                                        <b-form-input v-model="devedorEnderecoAlteracao.complementoAlteracao" type="text" id="complemento" maxlength="30" style="margin-left: 15px;"/>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                    <b-form-group label="Bairro:" label-for="bairroAlteracao" class="text-label">
                                        <b-form-input v-model="devedorEnderecoAlteracao.bairroAlteracao" type="text" id="bairro" maxlength="50" />
                                    </b-form-group>
                                </b-col>
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group label="Cidade:" label-for="cidadeAlteracao" class="text-label" style="margin-left: 15px;">
                                        <multiselect
                                            v-model="devedorEnderecoAlteracao.cidadeAlteracao"
                                            :selected="devedorEnderecoAlteracao.cidadeAlteracao"
                                            :show-labels="false"
                                            :options="dados.cidades"
                                            :multiple="false"
                                            :close-on-select="false"
                                            :clear-on-select="false"
                                            :preserve-search="true"
                                            placeholder="Selecione"
                                            label="nome"
                                            track-by="codMunicipio"
                                            style="margin-left: 15px;"
                                       />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group label="UF:" label-for="ufAlteracao" class="text-label">
                                        <multiselect
                                            v-model="devedorEnderecoAlteracao.ufAlteracao"
                                            :show-labels="false"
                                            :options="dados.ufs"
                                            :selected="devedorEnderecoAlteracao.ufAlteracao"
                                            :multiple="false"
                                            :close-on-select="false"
                                            :clear-on-select="false"
                                            :preserve-search="true"
                                            placeholder="Selecione"
                                            label="sigla"
                                            track-by="sigla"
                                       />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-form-group>
                        </b-card>
                        </div>
                        <template slot="modal-footer" slot-scope="{ ok, cancel }">
                            <!-- Emulate built in modal footer ok and cancel button actions -->
                            <b-button size="md" variant="success" @click="salvarDadosEnderecoDevedor()">
                                Salvar
                            </b-button>
                            <b-button size="md" @click="cancel()">
                                Fechar
                            </b-button>
                        </template>
                    </b-modal>
                    <CompBotoesFooter 
                        @exportCSV="exportCSV" 
                        @voltar="voltar" />
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import CompOpcoesPesquisa from '../shared/components/CompOpcoesPesquisaErroAjuizamentoProtesto'
import CompBotoesFooter from './components/CompBotoesFooter'
import CompPaginacao from './components/CompPaginacao'
import CompExibirOcultarColuna from './components/CompBotaoExibirOcultarColuna'
import CompTabelaErrosProtesto from './components/CompTabelaErrosProtesto'

export default {
    name: 'ExibirErrosProtesto',
    components: {
        CompOpcoesPesquisa,
        CompBotoesFooter,
        CompPaginacao,
        CompExibirOcultarColuna,
        CompTabelaErrosProtesto,
    },
    data() {
        return {
            ano: null,
            mes: null,
            devedorEndereco: null,
            devedorEnderecoAlteracao:{
                bairroAlteracao: null,
                cepAlteracao: null,
                cidadeAlteracao: null,
                complementoAlteracao: null,
                enderecoAlteracao: null,
                numeroEnderecoAlteracao: null,
                ufAlteracao: null,
            },
            filtro: {
                filtrosCombo: [],
                numeroDivida: null,
                cpfCnpj: null,
                contribuinte: null,
                cadimcs: null,
                comarca: null,
                tipoCredito: null,
                dtInscricaoInicio: null,
                dtInscricaoFim: null,
                erro: null,
            },
            dados: {
                comarcas: [],
                origens: [],
                creditos: [],
                cidades: [],
                ufs: [],
                filtrosCombo: [{codFiltro: 1, text: 'Nº da Dívida'}, {codFiltro: 2, text: 'CPF/CNPJ'}, {codFiltro: 3, text: 'Contribuinte'},
                {codFiltro: 4, text: 'CADICMS'},{codFiltro: 5, text: 'Comarca'},{codFiltro: 6, text: 'Tipo de Crédito'},{codFiltro: 7, text: 'Data de Inscrição'},{codFiltro: 8, text: 'Erro'}]
            },
            configTable: {
                perPage: 100,
                sortField: 'contribuinte',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
                totalGeral: 0.00,
                quantidadeGeral: 0
            },
            showColunms: [],
            selecteds: [],
            fields: [
                {
                    key: "selecionar",
                },
            ],
            resultado: [],
            loadCSV: false,
        }
    },
    watch: {
        perPage() {
            this.configTable.currentPage = 1
            this.consultarDividas()
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage
        },
        totalSelectedValue() {
            let total = 0.00
            this.selecteds.forEach(divida => {
                total = total + divida.valor
            })
            return total
        },
        totalResultValue() {
            let total = 0.00
            this.resultado.forEach(result => {
                result.dividas.forEach(divida => {
                    total = total + divida.valor
                })
            })
            return total
        },
    },
    methods: {
        salvarDadosEnderecoDevedor(){
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaErroProtesto/salvarEnderecoDevedorPrincipal`, this.devedorEnderecoAlteracao, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(() => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Dados do endereço do devedor principal atualizados com sucesso!'] });
                this.selecteds = []
            })
            .catch((error) => {
                if(error.response.status === 400){
                     this.$store.commit("setMessages", { message: 'Erro!', errors: ['Um erro ocorreu ao alterar os dados de endereço do devedor principal.'] });
                }
                if(error.response.status === 500){
                     this.$store.commit("setMessages", { message: 'Erro!', errors: ['Verifique os dados informados.'] });
                }
                this.selecteds = []
            })   
            .finally(() => {
                this.loadingExit()
                this.consultarDividas()
            })
        },
        show (divida) {
            this.devedorEndereco = divida.devedorEndereco;
            this.devedorEnderecoAlteracao.codCdaSefa = this.devedorEndereco.codCdaSefa;
            this.devedorEnderecoAlteracao.numeroCda = this.devedorEndereco.numeroCda;
            this.devedorEnderecoAlteracao.codDevedor = this.devedorEndereco.codDevedor;
            this.devedorEnderecoAlteracao.enderecoAlteracao = this.devedorEndereco.endereco;
            this.devedorEnderecoAlteracao.bairroAlteracao = this.devedorEndereco.bairro;
            this.devedorEnderecoAlteracao.cidadeAlteracao = this.devedorEndereco.cidade;
            this.devedorEnderecoAlteracao.cepAlteracao = this.devedorEndereco.cep;
            this.devedorEnderecoAlteracao.complementoAlteracao = this.devedorEndereco.complemento
            this.devedorEnderecoAlteracao.ufAlteracao = this.devedorEndereco.uf
            this.devedorEnderecoAlteracao.numeroEnderecoAlteracao = this.devedorEndereco.numeroEndereco;
            this.$refs['modalEndereco'].show();
        },
        hide () {
            this.$refs['modalEndereco'].hide();
        },
        /**
         * Limpar os filtros de pesquisa
         */
        limparFiltro() {
            this.filtro = {
                numeroDivida: null,
                cpfCnpj: null,
                contribuinte: null,
                cadimcs: null,
                comarca: null,
                tipoCredito: null,
                dtInscricaoInicio: null,
                dtInscricaoFim: null,
                erro: null,
            }
        },
        /**
         * Filtrar a consulta
         */
        filtrar() {
            this.configTable.currentPage = 1
            this.selecteds = []
            this.consultarDividas()
        },

        /**
         * Salva alterações de endereço do devedor principal
         */
        obterEnderecoPorCep() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadingEnter()
			axios.get(`${urlApi}/neocep/enderecamento/v3/endereco/${this.devedorEnderecoAlteracao.cepAlteracao}/${2}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
                .then(response => {
                    this.devedorEnderecoAlteracao.cidadeAlteracao = response.data.cidade;
                    this.devedorEnderecoAlteracao.ufAlteracao = response.data.uf;
                    this.devedorEnderecoAlteracao.enderecoAlteracao = response.data.endereco;
                    this.devedorEnderecoAlteracao.bairroAlteracao = response.data.bairro;
                    this.devedorEnderecoAlteracao.complementoAlteracao = response.data.complemento;
                }).finally(() => {
                   this.loadingExit()
                   this.consultarDividas()
                })
        },

        /**
         * Encaminha CDA's para disponiveis
         */
        encaminharParaDisponiveis() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaErroProtesto/encaminharDisponiveis`, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(() => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Dívidas foram encaminhadas para disponíveis com sucesso!'] });
                this.selecteds = []
            })
            .catch((error) => {
                if(error.response.status === 400){
                     this.$store.commit("setMessages", { message: 'Erro!', errors: ['Um erro ocorreu no desfazimento EPA-DAE, o histórico das dívidas selecionadas foi atualizado com o erro.'] });
                }
                this.selecteds = []
            })   
            .finally(() => {
                this.loadingExit()
                this.consultarDividas()
            })
        },

         /**
         * Lógica dos checks em nível dinâmico
         */
        toggleColuna(i) {
            let ativo;
            if(this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1)
                this.fields[i].thClass = 'd-none'
                this.fields[i].tdClass = 'd-none'
                ativo = false
            } else {
                this.showColunms.push(i)
                this.fields[i].thClass = ''
                this.fields[i].tdClass = ''
                ativo = true
            }

            this.refreshConfigColunm(i, ativo)
        },
        /**
         * Atualiza as configurações de coluna do usuário
         */
        async refreshConfigColunm(i, ativo) {
            const token = JSON.parse(this.$store.getters.getUser).access_token

            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo: ativo,
            }
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.post(`${urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })          
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        checkClassTable(i) {
            if(i == 1 || i == 2 || i == 5 || i == 6)
                return 'text-center'
            if(i == 7)
                return 'text-right'
            return ''
        },

         /**
         * Exporta as CDA's em CVS
         */
        async exportCSV() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadCSV = true
            if(this.selecteds.length) {
                this.loadingEnter()
                axios.post(`${urlApi}/v1/cdaErroProtesto/exportarCsv`, this.selecteds, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    this.downloadCSV(response)
                }).finally(() => {
                    this.loadCSV = false
                    this.loadingExit()
                })
            } else {
                const filtro = {
                    numeroDivida: this.filtro.numeroDivida,
                    cpfCnpj: this.filtro.cpfCnpj,
                    cadimcs: this.filtro.cadimcs,
                    comarca: this.filtro.comarca,
                    contribuinte: this.filtro.contribuinte,
                    credito: this.filtro.credito,
                    dtInscricaoInicio: this.filtro.dtInscricaoInicio ? this.filtro.dtInscricaoInicio.toString() : null,
                    dtInscricaoFim: this.filtro.dtInscricaoFim ? this.filtro.dtInscricaoFim.toString() : null,
                    erro: this.filtro.erro,
                }
                this.loadingEnter()
                axios.post(`${urlApi}/v1/cdaErroProtesto/exportarCsv/${this.ano}/${this.mes}?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    this.downloadCSV(response)
                }).finally(() => {
                    this.loadCSV = false
                    this.loadingExit()
                })
            }
        },

        /**
         * Efetua o download do CSV a partir do response
         */
        downloadCSV(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'CDAErroProtesto.csv');
            document.body.appendChild(link);
            link.click();
        },

        /**
         * Volta para a dashboard
         */
        voltar() {
            this.$router.push('/dashboard');
        },

        escapePerPage() {
            if (this.configTable.perPage == 'Todos') {
                return '';
            }
            return '&perPage='  + this.configTable.perPage
        },

         /**
         * Consultar divídas
         */
        async consultarDividas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = {
                numeroDivida: this.filtro.numeroDivida,
                cpfCnpj: this.filtro.cpfCnpj,
                contribuinte: this.filtro.contribuinte,
                cadimcs: this.filtro.cadimcs,
                comarca: this.filtro.comarca,
                credito: this.filtro.credito,
                dtInscricaoInicio: this.filtro.dtInscricaoInicio,
                dtInscricaoFim: this.filtro.dtInscricaoFim,
                erro: this.filtro.erro
            }

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaErroProtesto/consultar/${this.ano}/${this.mes}?page=${this.configTable.currentPage}` + this.escapePerPage()  + `&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                }
            })
            .then(response => {
                this.resultado = response.data.resultado
                this.configTable.rows = response.data.rows
                this.configTable.totalGeral = response.data.valorTotal
                this.configTable.quantidadeGeral = response.data.totalDividas

                this.resultado.forEach(result => {
                    this.selecteds.forEach(selected => {
                        if(result.id == selected.id) {
                            result.checked = true
                        }
                    })
                })
                
            }).finally(() => {
                this.loadingExit()
            })
        },

        /**
         * Listar comarcas
         */
        async listarComarcas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/comarca/listar/protesto`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.comarcas = response.data
            })
        },

        /**
         * Listar os Tipos de Crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/cdaErroProtesto/listarTipoCredito`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.creditos = response.data
            })
        },

        /**
         * Listar os Municipios
         */
        async listarMunicipios() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/municipio/listar`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.cidades = response.data
            })
        },

        /**
         * Listar as UF's
         */
        async listarUfs() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/cdaErroProtesto/listarUf`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.ufs = response.data
            })
        },

        /**
         * Obter configurações de colunas do usuário
         */
        async obterConfiguracaoUsuario() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token
            const funcionalidade = 'cdaErroProtesto'

            this.loadingEnter()
            axios.get(`${urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                response.data.forEach((field, i) => {
                    if(field.ativo) {
                        this.showColunms.push(i + 1)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        sortable: true,
                        sortDirection: "desc",
                        class: this.checkClassTable(i),
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            })
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingEnter() {
            this.configTable.load = true
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingExit() {
            this.configTable.load = false
        }

    },

    mounted() {
        const dataAtual = new Date(this.$store.getters.getDataMonitoramento)

        this.ano = dataAtual.getFullYear()
        this.mes = dataAtual.getMonth() + 1

        this.$store.commit("setMessages", {});

        this.consultarDividas()
        this.obterConfiguracaoUsuario()
        this.listarComarcas()
        this.listarTipoCredito()
        this.listarMunicipios()
        this.listarUfs()
    },

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.fonte-branca {
    color: #FFF;
}

.fonte-branca:hover {
    color: #FFF;
}

.fonte-branca:active {
    color: #FFF !important;
}

.table-sub-item, .table-sub-item > th, .table-sub-item > td {
    background-color: rgb(237, 237, 238);
}
</style>
